export default __webpack_public_path__ + "static/media/personality-small-refresh.62aeb4c0.svg";